import React, { useEffect, useState } from "react";
import { AiFillCloseCircle } from "react-icons/ai";
import axios from "axios";
import { useForm, useWatch } from "react-hook-form";
import toast from "react-hot-toast";

function AddElectricityModal({ isOpen, onClose, getAllElectricityBills }) {
  const [buildings, setBuildings] = useState([]);
  const [floors, setFloors] = useState([]);
  const [rooms, setRooms] = useState([]);
  const [selectedBuilding, setSelectedBuilding] = useState();
  const [selectedFloorNumber, setSelectedFloorNumber] = useState();
  const [load, setLoad] = useState(false);
  const [amount, setAmount] = useState(0);

  const {
    register,
    handleSubmit,
    clearErrors,
    setValue,
    watch,
    reset,
    formState: { errors },
  } = useForm({ defaultValues: {} });

  //Function to close the modal
  const closeModal = () => {
    onClose();
    clearErrors();
    reset();
    setAmount(0);
  };

  // console.log("Amount: ", watch("amount"));

  //Function to fetch all the buildings
  const fetchAllBuildings = () => {
    let config = {
      method: "get",
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_API_URL}/resources/get_all_building`,
      headers: {},
    };

    axios
      .request(config)
      .then((response) => {
        console.log("Response of fetchAllBuilding: ", response.data.data);
        setBuildings(response.data.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    fetchAllBuildings();
  }, [selectedBuilding]);

  //Fetch all floors of the selected building
  const getFloors = (buildingId) => {
    console.log("i am running--.", buildingId);

    let config = {
      method: "get",
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_API_URL}/resources/get_floors_by_building/${buildingId}`,
      headers: {},
    };

    axios
      .request(config)
      .then((response) => {
        console.log("Response of getFloors: ", response.data);
        setFloors(response.data.data.floorDetails);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  //Fetch all rooms of the selected floor
  const getRooms = (buildingId, floorNumber) => {
    console.log("Floor number: ", floorNumber);
    setSelectedFloorNumber(floorNumber);
    let config = {
      method: "get",
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_API_URL}/rooms/get_configured_room_by_building/${buildingId}/${floorNumber}`,
      headers: {},
    };

    axios
      .request(config)
      .then((response) => {
        console.log("Response of getRooms: ", response.data);
        setRooms(response.data.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  //Add electricity bill
  const handleAddElectricity = async (data) => {
    setLoad(true);
    const finalData = {
      ...data,
      amount: amount,
    };
    console.log("Data: ", data);
    let config = {
      method: "post",
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_API_URL}/electricity/add_electricity`,
      headers: {
        "Content-Type": "application/json",
      },
      data: finalData,
    };

    axios
      .request(config)
      .then((response) => {
        console.log("Response of handleAddElectricity: ", response.data);
        toast.success(response.data.message);
        setLoad(false);
        closeModal();
        getAllElectricityBills();
      })
      .catch((error) => {
        console.log(error);
        setLoad(false);
        toast.error(error.response.data.message);
        closeModal();
      });
  };

  if (!isOpen) return null;
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm">
      <div className="relative h-[31rem] md:h-auto overflow-y-scroll md:overflow-y-hidden bg-white p-8 lg:py-8 lg:px-16 rounded-lg shadow-lg w-full max-w-5xl">
        <div className="mb-6">
          <h2 className="text-2xl font-semibold text-center">
            Add Electricity
          </h2>
          <AiFillCloseCircle
            onClick={closeModal}
            className="cursor-pointer text-primaryColor absolute top-4 right-4"
            size={30}
          />
        </div>

        <form
          onSubmit={handleSubmit(handleAddElectricity)}
          className="grid grid-cols-1 sm:grid-cols-2 gap-4 p-4"
        >
          {/* Date */}
          <div>
            <label
              htmlFor="date"
              className="block text-sm font-medium text-gray-700"
            >
              Date
            </label>
            <input
              id="date"
              type="date"
              {...register("date", { required: "Date is required" })}
              className={`mt-1 p-3 block w-full border ${
                errors.date ? "border-red-500" : "border-gray-300"
              } rounded-md shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-md`}
            />
            {errors.date && (
              <span className="text-red-500 text-sm">
                {errors.date.message}
              </span>
            )}
          </div>

          {/* Building Name */}
          <div className="col-span-1">
            <label
              htmlFor="buildingName"
              className="block text-sm font-medium text-primaryTextColor"
            >
              Building Name <span className="text-red-500">*</span>
            </label>

            <select
              name="buildingName"
              id="buildingName"
              className={`mt-1 block w-full border ${
                errors.buildingId ? "border-red-500" : "border-gray-300"
              } rounded-md shadow-sm outline-none p-3`}
              {...register("buildingId", {
                required: "Building Name is required",
              })}
              onChange={(e) => {
                clearErrors("buildingId");
                setFloors([]);
                setRooms([]);
                setSelectedFloorNumber("");
                setSelectedBuilding(e.target.value);
                getFloors(e.target.value);
              }}
            >
              <option value="">Select Building</option>
              {buildings.map((item, index) => (
                <option key={index} value={item._id}>
                  {item.nameBuilding}
                </option>
              ))}
            </select>
            {errors.buildingId && (
              <span className="text-red-500 text-sm">
                {errors.buildingId.message}
              </span>
            )}
          </div>

          {/* Floor No */}
          <div className="col-span-1">
            <label
              htmlFor="floorNo"
              className="block text-sm font-medium text-primaryTextColor"
            >
              Floor No. <span className="text-red-500">*</span>
            </label>

            <select
              name="floorNo"
              id="floorNo"
              value={selectedFloorNumber}
              className={`mt-1 block w-full border ${
                errors.floorNo ? "border-red-500" : "border-gray-300"
              } rounded-md shadow-sm outline-none p-3`}
              {...register("floorNo", { required: "Floor No is required" })}
              onChange={(e) => {
                getRooms(selectedBuilding, e.target.value);
              }}
            >
              <option value="">Select Floor</option>

              {floors.map((f, index) => (
                <option key={index} value={f.floorNumber}>
                  Floor-{f.floorNumber}
                </option>
              ))}
            </select>
            {errors.floorNo && (
              <span className="text-red-500 text-sm">
                {errors.floorNo.message}
              </span>
            )}
          </div>

          {/* Room No */}
          <div className="col-span-1">
            <label
              htmlFor="roomId"
              className="block text-sm font-medium text-primaryTextColor"
            >
              Room No <span className="text-red-500">*</span>
            </label>
            <select
              name="roomNo"
              id="roomNo"
              className={`mt-1 block w-full border ${
                errors.roomId ? "border-red-500" : "border-gray-300"
              } rounded-md shadow-sm p-3`}
              {...register("roomId", { required: "Room No is required" })}
            >
              <option value="">Select Room</option>
              {rooms.map((room, index) => (
                <option key={index} value={String(room._id)}>
                  R-F{selectedFloorNumber}
                  {String(room.roomNumber).padStart(3, "0")}
                </option>
              ))}
            </select>
            {errors.roomNo && (
              <span className="text-red-500 text-sm">
                {errors.roomId.message}
              </span>
            )}
          </div>

          {/* Amount */}
          <div>
            <label
              htmlFor="amount"
              className="block text-sm font-medium text-gray-700"
            >
              Units <span className="text-red-500">*</span>
            </label>

            <input
              type="number"
              id="units"
              min={0}
              placeholder="Amount"
              className={`mt-1 p-3 block w-full border ${
                errors.units ? "border-red-500" : "border-gray-300"
              } rounded-md shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-md`}
              {...register("units", {
                required: "Units are required",
                min: {
                  value: 1,
                  message: "Amount must be at least 1",
                },
              })}
              onInput={(e) => {
                if (e.target.value === "") {
                  setAmount(0);
                  return;
                }
                if (e.target.value <= 0) {
                  e.target.value = "";
                  toast.error("Bill Amount can't be zero or negative");
                  return;
                }
                setAmount(e.target.value * 10);
              }}
            />
            {errors.units && (
              <span className="text-red-500 text-sm">
                {errors.units.message}
              </span>
            )}
          </div>

          {/* Amount */}
          <div>
            <label
              htmlFor="amount"
              className="block text-sm font-medium text-gray-700"
            >
              Bill Amount <span className="text-red-500">*</span>
            </label>

            <input
              type="number"
              disabled
              value={amount}
              id="amount"
              placeholder="Amount"
              className={`mt-1 p-3 block w-full border bg-gray-200 
                 border-gray-800
             rounded-md shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-md`}
            />
          </div>

          {/* Buttons */}
          <div className="sm:col-span-2 flex justify-between gap-6 mt-6 tracking-wide">
            <button
              className="bg-gray-100 w-full border text-xs sm:text-lg hover:bg-secondaryTextColor px-4 py-2 rounded-md"
              onClick={closeModal}
              type="button"
            >
              Cancel
            </button>

            <button
              type="submit"
              className="bg-primaryBtnColor text-xs sm:text-lg hover:bg-primaryBtnHoverColor w-full text-white px-4 py-2 rounded-md"
            >
              {load ? "Adding..." : "Add Electricity"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default AddElectricityModal;
